function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M86.4,48.6c-2,0-3.6,1.6-3.6,3.6v0H17.2V33.5c0-2-1.6-3.6-3.6-3.6c-2,0-3.6,1.6-3.6,3.6v34.4c0,1.2,0.9,2.2,2.1,2.2H15   c1.2,0,2.2-1,2.2-2.2v-8.6h65.6v8.6c0,1.2,1,2.2,2.1,2.2h2.9c1.2,0,2.2-1,2.2-2.2V52.1C90,50.2,88.4,48.6,86.4,48.6z"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "13.6,29.9 13.6,29.9 13.6,29.9  "
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.2,50.7h7.2c1.6,0,2.9-1.3,2.9-2.9c0-1.6-1.3-2.9-2.9-2.9h-7.2c-1.6,0-2.9,1.3-2.9,2.9C19.3,49.4,20.6,50.7,22.2,50.7z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 39.2,
  r: 5
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.8,49.9L33.8,49.9c1.1,1.1,2.9,1.1,4.1,0l9.1-9.1c1.1-1.1,1.1-2.9,0-4.1v0c-1.1-1.1-2.9-1.1-4.1,0l-9.1,9.1   C32.6,46.9,32.6,48.7,33.8,49.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.3,50.7h38.9c1.6,0,3-1.2,3-2.9v-6.3c0-2.8-2.3-5.1-5.2-5.1H56.6c-2.5,0-5,1-6.8,2.8L39.7,49.4   C39.2,49.9,39.6,50.7,40.3,50.7z"
}));

var SvgSleep = function SvgSleep(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: 30,
    height: 30,
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSleep, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sleep.87a3e31e.svg";
export { ForwardRef as ReactComponent };